"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var utils_1 = require("@doshexchnage/utils");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../../../../../../constants/routes");
var constants_1 = require("../../../constants");
var formatDelta = function (delta) { return "".concat(delta > 0 ? "+" : "").concat(delta.toLocaleString()); };
function useRenderCellViews() {
    var renderCellViews = (0, react_3.useCallback)(function (transaction) { return [
        { key: "date_time", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: (0, utils_1.formatDateTime)(new Date(transaction.date_time)) }) },
        {
            key: "display_name",
            content: ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.CUSTOMERS_ROUTE, "/").concat(transaction.user_id), className: "text-nowrap text-sm font-medium text-accent hover:underline", children: transaction.display_name || transaction.user_id })),
        },
        { key: "statistic", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: transaction.statistic }) },
        {
            key: "source_type",
            content: ((0, jsx_runtime_1.jsx)(react_1.Chip, { className: "text-nowrap", size: "sm", variant: "soft", children: (0, constants_1.sourceTypeLabel)(transaction.source_type) })),
        },
        { key: "operation", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-muted", children: (0, constants_1.operationLabel)(transaction.operation) }) },
        {
            key: "delta",
            content: ((0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm font-semibold ".concat(transaction.delta < 0 ? "text-danger" : "text-success"), children: formatDelta(transaction.delta) })),
        },
        {
            key: "value_after",
            content: ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-1 text-nowrap text-sm text-default-foreground", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-muted", children: transaction.value_before.toLocaleString() }), (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:arrow-right-linear", width: 14, className: "text-muted", "aria-label": "to" }), (0, jsx_runtime_1.jsx)("span", { className: "font-medium", children: transaction.value_after.toLocaleString() })] })),
        },
        { key: "version", content: (0, jsx_runtime_1.jsxs)("div", { className: "text-sm text-muted", children: ["v", transaction.version] }) },
        { key: "reason", content: (0, jsx_runtime_1.jsx)("div", { className: "max-w-[240px] truncate text-sm text-muted", children: transaction.reason || "None" }) },
    ]; }, []);
    return (0, react_3.useMemo)(function () { return ({ renderCellViews: renderCellViews }); }, [renderCellViews]);
}
